module.exports = __webpack_public_path__ + "static/media/bag_with_flower_page10.377533c8.gif";